(function(){
  var CFG=window.FVZ_BUNDLE;
  if(!CFG||!CFG.unitPrice){return;}
  function money(c){var cur=(CFG&&CFG.currency)||'USD';try{return new Intl.NumberFormat(undefined,{style:'currency',currency:cur}).format(c/100);}catch(e){return '$'+(c/100).toFixed(2);}}
  function qtyInputs(){return Array.prototype.slice.call(document.querySelectorAll('.product-form input[name=quantity], input.quantity__input[name=quantity]'));}
  function setQty(n){qtyInputs().forEach(function(inp){if(String(inp.value)!==String(n)){inp.value=n;inp.dispatchEvent(new Event('change',{bubbles:true}));}});}
  function anchorEl(){return document.querySelector('.product-form')||document.querySelector('product-form')||document.querySelector('.product-form__buttons');}
  function unitPrice(){
    try{
      var idEl=document.querySelector('.product-form [name="id"]')||document.querySelector('form[action*="/cart/add"] [name="id"]');
      if(idEl&&CFG.variantPrices){var p=CFG.variantPrices[String(idEl.value)];if(p!==undefined&&p!==null){return p;}}
    }catch(e){}
    return CFG.unitPrice;
  }
  function priceHTML(q,off,P){
    var orig=P*q,disc=Math.round(orig*(1-off)),save=orig-disc;
    if(off>0){return "<span class='fvz-was'>"+money(orig)+"</span><span class='fvz-now'>"+money(disc)+"</span><span class='fvz-save'>Save "+money(save)+"</span>";}
    return "<span class='fvz-now'>"+money(orig)+"</span>";
  }
  function build(){
    if(document.getElementById('fvz-bundle')){return;}
    var anchor=anchorEl();if(!anchor||!anchor.parentNode){return;}
    var P=unitPrice();
    var wrap=document.createElement('div');wrap.id='fvz-bundle';wrap.className='fvz-bundle';
    var html="<div class='fvz-bundle__title'>"+CFG.heading+"</div><div class='fvz-opts' role='radiogroup' aria-label='Choose your bundle'>";
    CFG.tiers.forEach(function(o){
      var badge=o.badge?("<span class='fvz-badge fvz-badge--"+o.badge.c+"'>"+o.badge.t+"</span>"):"";
      html+="<div class='fvz-opt' data-q='"+o.q+"' data-off='"+o.off+"' role='radio' aria-checked='false' tabindex='-1'><span class='fvz-radio' aria-hidden='true'></span><span class='fvz-info'><span class='fvz-name'>"+o.name+" "+badge+"</span><span class='fvz-sub'>"+o.sub+"</span></span><span class='fvz-pricewrap'>"+priceHTML(o.q,o.off,P)+"</span></div>";
    });
    html+="</div>";
    (CFG.reassure||[]).forEach(function(r){html+="<div class='fvz-reassure'>"+r+"</div>";});
    wrap.innerHTML=html;anchor.parentNode.insertBefore(wrap,anchor);
    wireSync(wrap);
    reprice();
  }
  function reprice(){
    var wrap=document.getElementById('fvz-bundle');if(!wrap){return;}
    var P=unitPrice();
    Array.prototype.forEach.call(wrap.querySelectorAll('.fvz-opt'),function(el){
      var q=parseInt(el.getAttribute('data-q'),10),off=parseFloat(el.getAttribute('data-off'));
      var pw=el.querySelector('.fvz-pricewrap');
      if(pw){pw.innerHTML=priceHTML(q,off,P);}
    });
  }
  function wireSync(wrap){
    var opts=wrap.querySelectorAll('.fvz-opt');
    function select(idx){for(var i=0;i<opts.length;i++){var on=i===idx;opts[i].classList.toggle('fvz-opt--active',on);opts[i].setAttribute('aria-checked',on?'true':'false');opts[i].tabIndex=on?0:-1;}}
    function choose(i){select(i);setQty(parseInt(opts[i].getAttribute('data-q'),10));}
    Array.prototype.forEach.call(opts,function(o,i){
      o.addEventListener('click',function(){choose(i);});
      o.addEventListener('keydown',function(e){
        if(e.key===' '||e.key==='Enter'){e.preventDefault();choose(i);}
        else if(e.key==='ArrowRight'||e.key==='ArrowDown'){e.preventDefault();var n=Math.min(opts.length-1,i+1);opts[n].focus();choose(n);}
        else if(e.key==='ArrowLeft'||e.key==='ArrowUp'){e.preventDefault();var p=Math.max(0,i-1);opts[p].focus();choose(p);}
      });
    });
    function syncFromQty(){var inp=qtyInputs()[0];var v=inp?parseInt(inp.value,10):1;if(isNaN(v)){v=1;}var idx=0;for(var i=0;i<opts.length;i++){if(v>=parseInt(opts[i].getAttribute('data-q'),10)){idx=i;}}select(idx);}
    syncFromQty();
    var first=qtyInputs()[0];if(first){first.addEventListener('change',syncFromQty);}
  }
  function hideLegacy(){
    try{
      var nodes=document.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,strong,legend,div');
      for(var i=0;i<nodes.length;i++){
        var el=nodes[i];
        if(el.children.length>0){continue;}
        if(el.closest&&el.closest('#fvz-bundle')){continue;}
        var t=(el.textContent||'').replace(/\s+/g,' ').trim().toUpperCase();
        if(t==='BUNDLE & SAVE'){
          var box=el;
          for(var k=0;k<6&&box.parentElement;k++){
            var pp=box.parentElement;
            if(pp.querySelector('form[action*="/cart/add"]')||pp.querySelector('[name=add]')||pp.id==='fvz-bundle'||(pp.querySelector&&pp.querySelector('#fvz-bundle'))){break;}
            box=pp;
            if(box.textContent.indexOf('%')>-1&&box.querySelectorAll('*').length>=4){break;}
          }
          if(box&&box!==document.body&&box.id!=='fvz-bundle'&&!box.querySelector('form[action*="/cart/add"]')&&!box.querySelector('[name=add]')&&!box.querySelector('#fvz-bundle')){box.style.display='none';}
          break;
        }
      }
    }catch(e){}
  }
  var lastVid=null;
  function checkVariant(){
    try{
      var idEl=document.querySelector('.product-form [name="id"]')||document.querySelector('form[action*="/cart/add"] [name="id"]');
      var v=idEl?String(idEl.value):null;
      if(v!==lastVid){lastVid=v;reprice();}
    }catch(e){}
    if(!document.getElementById('fvz-bundle')){try{build();}catch(e){}}
  }
  document.addEventListener('change',function(e){var t=e.target;if(t&&(t.name==='id'||(t.closest&&t.closest('variant-selects,variant-radios,.product-form__input')))){setTimeout(reprice,60);setTimeout(reprice,300);}});
  function run(){try{build();}catch(e){}hideLegacy();setTimeout(hideLegacy,700);setTimeout(hideLegacy,1800);}
  if(document.readyState!=='loading'){run();}else{document.addEventListener('DOMContentLoaded',run);}
  document.addEventListener('shopify:section:load',run);
  setInterval(checkVariant,600);
})();
